import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { store, useAppSelector } from '@/app/store';
import { checkNoError } from '@/features/channels/channelsSlice';
import { copyProjectRoom, getUnixEUTime, getProjectRoom, HotelInfoPublic, HotelRoom } from '@/features/projects/projectsSlice';

import Button from '@/components/Common/Button';
import Dropdown, { FieldInfo } from '@/components/Common/Dropdown';
import FlexRow, { FlexRowProps } from '@/components/Common/FlexRow';
import Input, { TextArea } from '@/components/Common/Input';
import MenuItem from '@/components/Common/MenuItem';
import Tabs from '@/components/Common/Tabs';

import { CatHeader } from '@/pages/Projects/Project';

import { getRoomUrl } from './ProjectRooms';

export interface ProjectRoomCloneProps {
  pub:					HotelInfoPublic | null;
  setRoom:				(room: HotelRoom) => Promise<boolean>;
}

const ProjectRoomClone = (props: ProjectRoomCloneProps) => {
  const { t } = useTranslation();
  
  const { tab_no } = useParams();
  const navigate = useNavigate();
  
  const [room_no, setRoom_no] = React.useState("");
  const [changes, setChanges] = React.useState(false);
  const [triedSave, SetTriedSave] = React.useState(false);
  const [room, setRoom] = React.useState(null as HotelRoom | null);
  
  const handleSave = React.useRef(() => { return; });
  
  React.useEffect(() => {
    setChanges(false);
    
    if (	!tab_no ||
    		!props.pub ||
        	!props.pub.rooms ||
        	!props.pub.rooms.rooms
       ) {
      setRoom(null);
      return;
    }
    
    const rume = getProjectRoom(props.pub, tab_no);
    setRoom(rume);
  }, [props.pub, tab_no])
  
  const room_noInvalid = React.useMemo(() => {
    let invalid =	!room_no ||
    				(	room_no &&
						room_no.trim() != '' &&
						!room_no.match(/^[a-zA-Z0-9_\.]+$/) &&
						room_no == tab_no
					)
					?	true
					:	false;
	
	if (	invalid ||
	    	!props.pub
	   ) {
	  return true;
	}
	
	const rume = getProjectRoom(props.pub, room_no);
	if (rume)
	  invalid = true;
	
	return invalid;
  }, [props.pub, room_no, tab_no]);
  
  handleSave.current = async () => {
    if (	!room_no ||
        	!room ||
        	!props.pub
       )
      return;
    
    if (room_noInvalid) {
      SetTriedSave(true);
      return;
    }
    
    let newRoom = copyProjectRoom(room);
    newRoom.room_no = room_no;
    newRoom.old_room_no = "";
    newRoom.duid = "";
    newRoom.is_new = true;
    
    const success = await props.setRoom(newRoom);
    if (!success)
      return;
    
    /*const mess = await store.setRoom(newRoom);
    console.log("ProjectRoomClone/handleSave/mess=", mess);
    
    if (!checkNoError(mess))
      return;*/
    
    SetTriedSave(false);
    
    navigate(`/projects/${encodeURIComponent(props.pub.id)}/rooms`)
  };
  
  const updateRoom_no = (val: string) => {
    setChanges(true);
    setRoom_no(val);
  };
  
  const loaded = props.pub && tab_no ? true : false;
  
  return (
  <React.Fragment>
    <FlexRow direction="column"
             align="start"
             className="px-[32px]">
      <FlexRow direction="column"
		       align="start"
		       className="py-0 gap-[16px] max-w-[620px]">
		<CatHeader caption="projects:project:rooms:clone_room:caption_n"
		           captionProps={{n: tab_no}} />
		<Input label={t('projects:project:rooms:clone_room:room_no:caption')}
		       placeholder={t('projects:project:rooms:clone_room:room_no:placeholder')}
		       isLoaded={loaded}
		       isInvalid={triedSave && room_noInvalid}
		       errorMessage={t('projects:project:rooms:clone_room:room_no:invalid')}
		       value={room_no}
		       onValueChange={updateRoom_no} />
	  </FlexRow>
    </FlexRow>
    <FlexRow className="absolute bottom-0 p-[32px] bg-white z-10 justify-end gap-[16px]">
      <Button className="uppercase"
              caption={t('projects:project:rooms:clone_room:cancel')}
              onClick={() => props.pub && navigate(`/projects/${encodeURIComponent(props.pub.id)}/rooms`)}
              layout="white" />
      <Button className="uppercase"
              caption={t('projects:project:rooms:clone_room:save')}
              icon="save"
              isDisabled={
              	!changes ||
              	(	triedSave &&
              		room_noInvalid
				)
			  }
              onClick={() => handleSave.current()} />
    </FlexRow>
  </React.Fragment>
  );
};

export default ProjectRoomClone;


